/**
 * Generated by orval v6.16.0 🍺
 * Do not edit manually.
 * Neubie Order
 * Neubie Order API Server
 * OpenAPI spec version: V1
 */

export type ShopsListShopStatusItem = (typeof ShopsListShopStatusItem)[keyof typeof ShopsListShopStatusItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShopsListShopStatusItem = {
  APPROVED: 'APPROVED',
  DELETED: 'DELETED',
  REJECTED: 'REJECTED',
  REQUEST: 'REQUEST',
  SUSPENDED: 'SUSPENDED'
} as const
